import createVueComponent from '../createVueComponent';

const Snowflake = createVueComponent('SnowflakeIcon', [
  ['line', { x1: '2', x2: '22', y1: '12', y2: '12', key: '1dnqot' }],
  ['line', { x1: '12', x2: '12', y1: '2', y2: '22', key: '7eqyqh' }],
  ['path', { d: 'm20 16-4-4 4-4', key: 'rquw4f' }],
  ['path', { d: 'm4 8 4 4-4 4', key: '12s3z9' }],
  ['path', { d: 'm16 4-4 4-4-4', key: '1tumq1' }],
  ['path', { d: 'm8 20 4-4 4 4', key: '9p200w' }],
]);

export default Snowflake;
